export default __webpack_public_path__ + "static/media/base-report6.cf6d2a0e.png";